import React, { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import api from "../lib/api";
import { useNavigate } from "react-router-dom";

export default function NotificationBell() {
  const [count, setCount] = useState(0);
  const nav = useNavigate();

  const load = async () => {
    try {
      const { data } = await api.get("/notifications");
      const list = Array.isArray(data) ? data : (data.items || []);
      setCount(list.filter(n => !n.read).length);
    } catch { /* ignore */ }
  };

  useEffect(() => {
    load();
    const t = setInterval(load, 60000); // every minute
    return () => clearInterval(t);
  }, []);

  return (
    <button
      data-testid="notification-bell"
      onClick={() => nav("/app/notifications")}
      className="relative p-2 rounded-md text-slate-600 hover:text-slate-900 hover:bg-slate-100"
      title="Notifications"
    >
      <Bell className="w-4 h-4" />
      {count > 0 && (
        <span data-testid="notification-count" className="absolute top-0 right-0 inline-flex items-center justify-center min-w-[16px] h-[16px] text-[9px] font-bold text-white bg-red-600 rounded-full px-1">
          {count > 99 ? "99+" : count}
        </span>
      )}
    </button>
  );
}
